<div [ngClass]="{ active: docsEditable }" class="files-preview-container">
  <div (fileDropped)="onFileDropped($event)" [hidden]="!docsEditable" appDnd class="dnd-container">
    <!-- accept="image/png, image/jpeg, application/pdf, .doc, .docx, .xlsx, .xls, .zip, .rar , .ppt, .pptx" -->
    <input #fileDropRef
      (change)="fileBrowseHandler($event)"
      [attr.id]="'videoDropRef_' + managerIndex"
      [disabled]="isDisabled" multiple type="file" />
    <div>
      <svg height="25" width="19" viewBox="0 0 19 25">
        <path
          d="M11362.336-8571a2.322,2.322,0,0,1-2.336-2.3v-15.742h4.725a2.321,2.321,0,0,0,2.335-2.3V-8596h9.605a2.317,2.317,0,0,1,2.335,2.3v20.4a2.317,2.317,0,0,1-2.335,2.3Zm6.421-5.439a.738.738,0,0,0,.743.732.738.738,0,0,0,.743-.732v-5.292l1.916,1.887a.75.75,0,0,0,1.051,0,.723.723,0,0,0,0-1.035l-3.185-3.138a.749.749,0,0,0-1.05,0l-3.185,3.138a.725.725,0,0,0,0,1.035.75.75,0,0,0,1.051,0l1.915-1.887Zm-3.184-10.2a.738.738,0,0,0,.743.732h6.368a.738.738,0,0,0,.743-.732.737.737,0,0,0-.743-.732h-6.368A.738.738,0,0,0,11365.573-8586.638Zm-5.573-3.871v-.052a.729.729,0,0,1,.219-.518l4.776-4.707a.747.747,0,0,1,.524-.215h.054v4.654a.844.844,0,0,1-.849.837Z"
          fill="#e48d1a" id="upload-icon" transform="translate(-11360 8596)" />
      </svg>
    </div>
    <h4>{{ label ? label : ('fileManager.Drag and drop' | translate) }}</h4>
    <div>
      <span>{{ (label ? 'fileManager.Or' : 'fileManager.Supporting Extensions here Or') | translate }}</span>
      <label [attr.for]="'videoDropRef_' + managerIndex">{{"fileManager.Browse Your Files" | translate}}</label>
    </div>
    <div class="hint">
      {{"fileManager.Supported Formats:" | translate}}
      <span>{{allowedExt}}</span>
    </div>
    <span class="d-block mt-2">{{ "fileManager.Max File Size" | translate: { maxFileSize: maxFileSize } }}</span>
  </div>


  <div *ngIf="selectedfilesCount > maxFiles && maxFiles > 1" class="has-error">
    {{ 'fileManager.Maximum allowed files is' | translate: { maxFiles: maxFiles } }}
  </div>
  <div *ngIf="selectedfilesCount > maxFiles && maxFiles === 1" class="has-error">
    {{ 'fileManager.Only One File is allowed' | translate }}
  </div>
  <div *ngIf="!validFile" class="has-error">{{"fileManager.Invalid File Extensions" | translate}}</div>
  <div *ngIf="fileMaxSiZeErorr" class="has-error">{{ "fileManager.Max File Size" | translate: { maxFileSize: maxFileSize
    } }}</div>
  <div *ngIf="fileMaxNameSiZeErorr" class="has-error"></div>
  <div *ngIf="!files.length && isRequired && isSubmitted" class="has-error">
    {{"forms.Required" | translate}}
  </div>
  <div *ngIf="!files.length" [hidden]="docsEditable" class="dnd-container">
    <h4>{{"fileManager.No Files" | translate}}</h4>
  </div>


  <div class="files-list">
    <div class="row">
      <div *ngFor="let file of files; let i = index" class="col-6">
        <div *ngIf="file" class="file-item d-block">
          <div class="thumbnail-container">
            <img [src]="file?.thumbStr" />
          </div>
          <div class="p-3">
            <label [title]="file.file?.name">{{ file.file?.name }}</label>
            <span>{{ formatBytes(file.file?.size) }}</span>
          </div>

          <div class="d-flex align-items-center justify-content-between file-btn pb-3 px-3">
            <div>
              <label [matTooltip]="'fileManager.Change thumbnail' | translate"
                [for]="managerIndex+'_'+i+'_videoThumb'">
                <mat-icon>add_photo_alternate</mat-icon>
              </label>

              <input class="d-none" type="file" [id]="managerIndex+'_'+i+'_videoThumb'"
                accept="image/jpeg, image/pjpeg, image/png"
                (change)="changeThumbListener($event, i)" />
            </div>
            <div>
              <button (click)="deleteFile(i, file.id)" class="btn-delete">
                <svg height="20" viewBox="0 0 20 20" width="20">
                  <path
                    d="M0,10A9.938,9.938,0,0,1,10,0,9.938,9.938,0,0,1,20,10,9.938,9.938,0,0,1,10,20,9.938,9.938,0,0,1,0,10Zm1.429,0A8.571,8.571,0,1,0,10,1.429,8.6,8.6,0,0,0,1.429,10ZM10,11.143,6.143,15,5,13.857,8.857,10,5,6.143,6.143,5,10,8.857,13.857,5,15,6.143,11.143,10,15,13.857,13.857,15Z"
                    data-name="Union 4" fill="#959595" id="Union_4" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
